//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import { CustomDataGeographicOrAggregateFilter } from "shared/search/containers/Filter/CustomDataFilters"

export const CustomDataGeographicFilterGroup = (props) => genericFilterGroup(props)
CustomDataGeographicFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
CustomDataGeographicFilterGroup.defaultProps = {
    filters: [CustomDataGeographicOrAggregateFilter],
    uniqueFilterGroupId: "geographyRegionFilterGroup",
    displayLabel: "Footprint Data Type",
    helpText: "Filter by whether the Footprint Data is from a Geographic or Aggregate source",
}
